<template>
  <div class="row">
    <div class="col-md-12">
      <form class="g-brd-around g-brd-gray-light-v4 g-pa-30 g-mb-30">
        <div class="form-inline">

          <Farms v-bind:farm="selectedFarm" @farmChanged="farmChanged" v-bind:showAllFarms="canSeeAllFarms"
                 v-bind:excludeFarmTypes="excludeFarmTypes"></Farms>

          <select v-model="selectedMonth" class="form-control rounded-0 mb-25 ml-md-3 mt-2 mt-md-0">
            <option v-for="month in months" :value="month" v-bind:key="month.value">
              {{ month.text }}
            </option>
          </select>

          <select v-model="selectedYear" class="form-control rounded-0 mb-25 ml-md-3 mt-2 mt-md-0">
            <option v-for="year in years" :value="year" v-bind:key="year">
              {{ year }}
            </option>
          </select>

          <button type="button" class="btn btn-md u-btn-primary rounded-0 ml-md-3 ml-0 mb-25 mt-2 mt-md-0"
                  @click="filter">Go
          </button>
        </div>

      </form>
    </div>
  </div>


</template>

<script>
import {onMounted, ref, toRefs, watch} from "vue";

import Farms from './Farms.vue'

export default {
  name: 'reportfilter',
  components: {
    Farms
  },
  props: {
    farm: String,
    month: Number,
    year: Number,
    showAllFarms: Boolean,
    excludeFarmTypes: {
      type: Array,
      // Object or array defaults must be returned from
      // a factory function
      default() {
        return []
      }
    },
  },
  emits: ['filter'],
  setup(props) {

    const {farm, month, year, showAllFarms} = toRefs(props);

    const years = ref([]);
    const months = ref([]);
    const canSeeAllFarms = ref(false);

    const selectedFarm = ref();
    const selectedMonth = ref();
    const selectedYear = ref();

    const setupFilter = () => {
      const today = new Date();
      years.value.push(today.getFullYear());
      years.value.push(today.getFullYear() - 1);
      years.value.push(today.getFullYear() - 2);

      months.value = [
        {text: 'Jan', value: 1},
        {text: 'Feb', value: 2},
        {text: 'Mar', value: 3},
        {text: 'Apr', value: 4},
        {text: 'May', value: 5},
        {text: 'Jun', value: 6},
        {text: 'Jul', value: 7},
        {text: 'Aug', value: 8},
        {text: 'Sep', value: 9},
        {text: 'Oct', value: 10},
        {text: 'Nov', value: 11},
        {text: 'Dec', value: 12},
      ];

      selectedMonth.value = months.value[0];
      selectedYear.value = years.value[0];

      canSeeAllFarms.value = showAllFarms.value;

    };

    onMounted(setupFilter);
    watch(farm, newVal => {
      selectedFarm.value = newVal;
    });
    watch(month, newVal => {
      selectedMonth.value = months.value.find(m => m.value === newVal);
    });
    watch(year, newVal => {
      selectedYear.value = years.value.find(y => y === newVal);
    });
    watch(showAllFarms, newVal => {
      canSeeAllFarms.value = newVal;
    });

    //watch

    return {
      months,
      years,
      selectedMonth,
      selectedYear,
      selectedFarm,
      canSeeAllFarms
    }
  },
  data() {
    return {}
  },
  methods: {
    filter: function () {
      this.$emit('filter', {farm: this.selectedFarm, month: this.selectedMonth.value, year: this.selectedYear});
    },
    farmChanged: function (farm) {
      this.selectedFarm = farm;
    }
  }
}
</script>